import queryString from "query-string";

export default function strToObj(str = "") {
  return queryString.parse(str, { parseBooleans: true });
}
